/**
 * Official social profiles — used in the site footer.
 * Leave a string empty to show the icon as “coming soon” until the link is ready.
 */
export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/share/17bLAd2Npn/?mibextid=wwXIfr',
  instagram: 'https://www.instagram.com/chooserightcareer.in?igsh=cjFvZjBrbGIybDRn&utm_source=qr',
  threads: '',
  linkedin: '',
};
